module.exports = __webpack_public_path__ + "static/media/user_profile_female.d7a3ec35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_profile_female.jpg
// module id = 117
// module chunks = 0